import { render, staticRenderFns } from "./SetGradingCriteria.vue?vue&type=template&id=5cbef4a0&scoped=true&"
import script from "./SetGradingCriteria.vue?vue&type=script&lang=js&"
export * from "./SetGradingCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbef4a0",
  null
  
)

export default component.exports